(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/checkbox-item.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/checkbox-item.js');
'use strict';

const Checkbox = svs.ui.reactForm.Checkbox;

const CheckboxItem = _ref => {
  let title = _ref.title,
    id = _ref.id,
    model = _ref.model,
    onChange = _ref.onChange;
  return React.createElement(Checkbox, {
    checked: model[id],
    id: id,
    onChange: () => onChange(id)
  }, title);
};
svs.myProfile.react.shared.components.CheckboxItem = CheckboxItem;

 })(window);